module.exports = __webpack_public_path__ + "static/media/cosmonaut.12b73e0e.png";